import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { InformativaText } from "../components/ConsensiPrivacy";
import { Loader2 } from "lucide-react";

export default function PrivacyPage() {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/public/privacy").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-background px-4 py-12" data-testid="privacy-page">
      <div className="mx-auto max-w-2xl">
        <h1 className="text-3xl font-heading font-bold mb-6">Informativa sul trattamento dei dati personali</h1>
        {info ? <div className="text-sm [&_*]:text-sm"><InformativaText info={info} /></div> : <Loader2 className="h-5 w-5 animate-spin text-primary" />}
      </div>
    </div>
  );
}
